import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { InputProps } from "../common/inputProps";
import { ChangeEvent, forwardRef, useEffect, useState, useCallback } from "react";
import { downloadReciptFinancial, getReciptFinancial } from "../../../features/financial/service/financeiro-service";
import { FILES_BASE_URL } from "../../../shared/utils/variables";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const InputFileUpload = forwardRef<HTMLInputElement, InputProps>(
    ({ error, placeholder, value, onChange, name, required = false, width = 300, height = 55, disabled = false }, ref) => {
      const [selectedImage, setSelectedImage] = useState<string | null>(null);
  
      const fetchImage = useCallback(async () => {
        try {
          if (value instanceof File) {
            const imageUrl = URL.createObjectURL(value);
            setSelectedImage(imageUrl);
            return;
          }

          if (value?.financialId) {
            const imageUrl = await getReciptFinancial(value.financialId);
            setSelectedImage(imageUrl);
            return;
          }

          if (typeof value === 'string') {
            setSelectedImage(value);
            return;
          }

          if (value && value.path) {
            setSelectedImage(`${FILES_BASE_URL}/${value.path}`);
            return;
          }

          setSelectedImage(null);

        } catch (error) {
          console.error('Erro ao carregar imagem:', error);
          setSelectedImage(null);
        }
      }, [value]);

      useEffect(() => {
        fetchImage();
      }, [fetchImage]);

      const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
        
            if (!file.type.startsWith("image/")) {
              alert("Por favor, selecione um arquivo de imagem.");
              return;
            }
        
            const imageUrl = URL.createObjectURL(file);
            setSelectedImage(imageUrl);
        
            if (onChange) {
              onChange(file as any);
            }
          }
      };

      const handleDownload = async () => {
        if (value?.financialId) {
            try {
                await downloadReciptFinancial(value.financialId, value.filename as string);
            } catch (error) {
                console.error('Erro ao baixar recibo:', error);
            }
        }
      };
  
      return (
        <Box sx={{ width: width, display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            component="label"
            variant="contained"
            startIcon={<CloudUploadIcon />}
            sx={{
              backgroundColor: "#4db0b1",
              "&:hover": { backgroundColor: "#3a8d8e" },
              width: "100%",
              height: height,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textTransform: "none",
            }}
            disabled={disabled}
          >
            {placeholder || "Escolher Imagem"}
            <VisuallyHiddenInput
              type="file"
              accept="image/*"
              name={name}
              onChange={handleImageChange}
              ref={ref}
              disabled={disabled}
            />
          </Button>
  
          {selectedImage && (
            <Box
              component="img"
              src={selectedImage}
              alt="Preview"
              sx={{ width: 150, height: 150, borderRadius: 2, objectFit: "cover" }}
              onClick={handleDownload}
            />
          )}
        </Box>
      );
    }
  );

export default InputFileUpload;
